import { LIST_MEMBERSHIP, USER_LIST_MEMBERSHIP } from 'utils/fieldConstants';
import { isDefined } from 'utils/tsHelpers';
import { ComparatorsDropdownProps } from '../types';
import { isCatalog } from '../../../utils/isCatalog';
import { isCustomValueType } from '../../../utils/isCustomValueType';

export const listMembershipFields = [LIST_MEMBERSHIP, USER_LIST_MEMBERSHIP];

export const withMultiSelectInputComparators = (
  {
    esIndex,
    isMultiSelectInputAllowed,
    multiSelectInputComparators,
    isMultiSelectWithListMembershipAllowed,
    valueType,
  }: ComparatorsDropdownProps,
  field?: string,
) => {
  const isListMembershipField = isDefined(field) && listMembershipFields.includes(field);
  const hasComparators =
    !isCatalog(esIndex) && isCustomValueType(valueType) && isMultiSelectInputAllowed;

  if (isListMembershipField && !isMultiSelectWithListMembershipAllowed) return [];
  return hasComparators ? multiSelectInputComparators : [];
};
